import { defineMessages, FormattedMessage } from 'react-intl';

import { Select } from '../../../../forms/select/index';
import residentialOptions from '../../../../helpers/residentialOptions';
import styles from '../PersonModal.module.css';

const residentialOptionMessages = defineMessages({
    tenant: {
        id: '_.residential_options.tenant',
        defaultMessage: 'Tenant'
    },
    owner_with_mortgage: {
        id: '_.residential_options.owner_with_mortgage',
        defaultMessage: 'Owner occupier (with mortgage)'
    },
    owner_no_mortgage: {
        id: '_.residential_options.owner_no_mortgage',
        defaultMessage: 'Owner occupier (no mortgage)'
    },
    rent_free: {
        id: '_.residential_options.rent_free',
        defaultMessage: 'Living rent free (e.g. with parents)'
    }
});

export const ResidentialStatusQuestion = ({ name }: { name: string }) => {
    return (
        <Select
            name={name}
            label={
                <FormattedMessage
                    id="_.person.residential_status"
                    defaultMessage="Residential status"
                />
            }
            placeholder={
                <FormattedMessage
                    id="_.person.residential_status_placeholder"
                    defaultMessage="Select residential status..."
                />
            }
            selectOptions={{
                classNameSelect: styles.ResidentialStatusSelect,
                options: residentialOptions
            }}
            messages={residentialOptionMessages}
        />
    );
};
